/* unplugin-vue-components disabled */import { render } from "./AggregatePrice.vue?vue&type=template&id=1fb47a41&scoped=true&ts=true"
import script from "./AggregatePrice.vue?vue&type=script&lang=ts"
export * from "./AggregatePrice.vue?vue&type=script&lang=ts"

import "./AggregatePrice.vue?vue&type=style&index=0&id=1fb47a41&lang=less&scoped=true"
import "./AggregatePrice.vue?vue&type=style&index=1&id=1fb47a41&lang=css"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb47a41"]])

export default __exports__